import { Tv, Clapperboard, Star, ShieldCheck } from "lucide-react";
import Reveal from "./Reveal";
import GridTexture from "./GridTexture";

const STATS = [
  { icon: Tv, value: "79.000+", label: "Live zenders" },
  { icon: Clapperboard, value: "249.000+", label: "Films & series" },
  { icon: Star, value: "4.9/5", label: "12.000+ beoordelingen" },
  { icon: ShieldCheck, value: "15 dagen", label: "Geld-terug-garantie" },
];

export default function TrustBar() {
  return (
    <section className="bg-surface-primary border-y border-line relative z-10 overflow-hidden">
      <GridTexture fade={false} />
      <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto py-6 sm:py-8 relative">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {STATS.map((stat, i) => (
            <Reveal
              key={stat.label}
              delay={i * 80}
              className="bg-surface-card rounded-xl sm:rounded-2xl p-4 sm:p-5 h-full flex items-center gap-3 sm:gap-4"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-button flex items-center justify-center flex-shrink-0 shadow-glow-purple-sm">
                <stat.icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
              </div>
              <div className="text-left min-w-0">
                <div className="text-base sm:text-xl font-black text-white leading-tight">
                  {stat.value}
                </div>
                <div className="text-[11px] sm:text-xs font-medium text-ink-muted leading-tight">
                  {stat.label}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
